import SubscriptionManager from './util/SubscriptionManager';

class StationIdHoverSync {
	constructor() {
		this.subscriptionManager = new SubscriptionManager();
		this.stationId = undefined;
		this.pageWideSelectedReading = undefined;
		this.pageWideSelectedReadingSurvey = undefined;
		this.allComponentsLocked = undefined;
	}

	hasChangeStationId({ 
		stationId = this.stationId,
	} = {}) {
		return this.stationId !== stationId;
	}

	hasChangeSelectedReadingProps({ 
		pageWideSelectedReading,
		pageWideSelectedReadingSurvey,
		allComponentsLocked,
	} = {}) {
		return pageWideSelectedReading?.id !== this.pageWideSelectedReading?.id ||
			pageWideSelectedReadingSurvey !== this.pageWideSelectedReadingSurvey ||
			allComponentsLocked !== this.allComponentsLocked;
	}

	updateStationId(stationId, callingObj) {
		if (this.hasChangeStationId({ stationId })) {
			// console.log(`CHANGE --> ${callingObj.trackingId}`);

			this.stationId = stationId;

			const subscribed = this.subscriptionManager.getSubscribed({
				ignore: [callingObj]
			});
			subscribed.forEach(({ f: func }) => {
				func(stationId);
			});
		}
	}

	updateSelectedReadingProps(
		{
			pageWideSelectedReading,  
			pageWideSelectedReadingSurvey, 
			allComponentsLocked, 
		} = {},
		callingObj
	) {

		if (this.hasChangeSelectedReadingProps({ pageWideSelectedReading, pageWideSelectedReadingSurvey, allComponentsLocked })) {
			// console.log(`CHANGE --> ${callingObj.trackingId}`);

			this.pageWideSelectedReading = pageWideSelectedReading;
			this.pageWideSelectedReadingSurvey = pageWideSelectedReadingSurvey;
			this.allComponentsLocked = allComponentsLocked;

			const subscribed = this.subscriptionManager.getSubscribed({
				ignore: [callingObj]
			});
			subscribed.forEach(({ f: func }) => {
				func(this.stationId);
			});
		}
	}

	subscribe(obj, fnRecieveZoomUpdate) {
		this.subscriptionManager.subscribe(obj, fnRecieveZoomUpdate);
	}

	unsubscribe(obj) {
		this.subscriptionManager.unsubscribe(obj);
	}
}

export default new StationIdHoverSync();
